export default __webpack_public_path__ + "static/flipImg5-157ae5e22432b0abb7b3439b69824bc5.webp";